import axios from '../api'
import {
  GetTurnstileToken,
  TURNSTILE_HEADER,
  takeChallengeToken,
} from '../turnstile/challenge'

interface RetrieveReporterReportRequest {
  /** The unique code the reporter was given when they filed the report. */
  code: string
  getToken: GetTurnstileToken
}

/**
 * Looks a report up by its unique code, for the reporter. This is a GET, so
 * the Turnstile token travels in a header rather than the body.
 */
export const retrieveReporterReport = async ({ code, getToken }: RetrieveReporterReportRequest) => {
  const token = await takeChallengeToken(getToken)

  return axios.get('/report/report/retrieve-report/', {
    headers: {
      Token: code,
      ...(token ? { [TURNSTILE_HEADER]: token } : {}),
    },
  })
}
